import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AnalyticsResponseDto } from '@api/models/analytics/AnalyticsResponseDto';
import { KpiTile } from './KpiTile';
import { KpiDurationTile } from './KpiDurationTile';
import { KpiRow, KpiStripWrapper } from '../AnalyticsStyles';
import { EMPTY_CELL, formatCellValue } from '../analyticsColumns';

interface Props {
  data: AnalyticsResponseDto | null | undefined;
  loading?: boolean;
}

export const AnalyticsKpiStrip: FC<Props> = ({ data, loading }) => {
  const { i18n } = useTranslation();
  const totals = data?.totals;

  return (
    <KpiStripWrapper>
      <KpiRow className="kpi-row-host">
        <KpiTile
          labelKey="analytics.kpi.total"
          tooltipKey="analytics.kpi.tooltip.total"
          value={totals ? formatCellValue(totals.count, 'INT', i18n) : EMPTY_CELL}
          loading={loading}
        />
        <KpiTile
          labelKey="analytics.kpi.completed"
          tooltipKey="analytics.kpi.tooltip.completed"
          value={totals ? formatCellValue(totals.completedCount, 'INT', i18n) : EMPTY_CELL}
          tone="positive"
          loading={loading}
        />
        <KpiDurationTile
          avg={totals ? formatCellValue(totals.average, 'DURATION_SEC', i18n) : EMPTY_CELL}
          median={totals ? formatCellValue(totals.median, 'DURATION_SEC', i18n) : EMPTY_CELL}
          loading={loading}
        />
        <KpiTile
          labelKey="analytics.kpi.sumDuration"
          tooltipKey="analytics.kpi.tooltip.sumDuration"
          value={totals ? formatCellValue(totals.sum, 'DURATION_SEC', i18n) : EMPTY_CELL}
          loading={loading}
        />
      </KpiRow>
    </KpiStripWrapper>
  );
};
